import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GenericObj } from '../../../helpers/customHooks/useButtons';
import InvoiceForm from '../../Accounting/Invoices/InvoiceForm';
import EntityInvoiceList from './EntityInvoiceList';

interface EntityInvociesProps {
  entity_id: number;
  goBack: React.MutableRefObject<() => void>;
  history: ReturnType<typeof useHistory>;
  setButtonProperty: (payload: GenericObj) => void;
}
const EntityInvocies: React.FC<EntityInvociesProps> = ({ entity_id, goBack, history, setButtonProperty }) => {
  const [selectedInvoice, setSelectedInvoice] = useState<number | null>(null);

  const onGoBack = () => {
    setSelectedInvoice(null);
  };

  useEffect(() => {
    goBack.current =
      selectedInvoice !== null
        ? onGoBack
        : () => {
            history.go(-1);
          };

    return () => {
      goBack.current = () => history.go(-1);
    };
  }, [goBack, history, selectedInvoice]);

  return (
    <>
      {selectedInvoice || selectedInvoice === 0 ? (
        <InvoiceForm invoice_id={selectedInvoice} setButtonProperty={setButtonProperty} hidden />
      ) : (
        <EntityInvoiceList
          entity_id={entity_id}
          setButtonProperty={setButtonProperty}
          selectInvoice={(invoice_id: number) => {
            setSelectedInvoice(invoice_id);
          }}
        />
      )}
    </>
  );
};

export default EntityInvocies;
